import React from 'react'
import './tag.component.css';

export default function Tag({text, cssClass}) {
  return (
    <div className={`tag ${cssClass}`}>
      <div className='tag-content'>
        {text}
      </div>
      </div>
  )
}
